export default __webpack_public_path__ + "static/Olark-39db4b83a387b3771e9f1184e8b3391a.png";